import { inject, Injectable } from '@angular/core';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { PtiControllerApi } from '../../../api/services/pti-controller-api';
import { CreatePtiResponse } from '../../../api/models/create-pti-response';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PtiService {
  private readonly logger: LoggerWrapper = inject(LoggerWrapper);
  private readonly ptiApi: PtiControllerApi = inject(PtiControllerApi);

  async createPTI(dkCodeResource: string): Promise<CreatePtiResponse> {
    try {
      const params = { body: { dkCodeRessource: dkCodeResource } };
      this.logger.info('createPTI: Calling API, request={}', params);
      return await firstValueFrom(this.ptiApi.createPti(params));
    } catch (e) {
      this.logger.error(e, 'createPTI: Error calling API, dkCodeResource={}', dkCodeResource);
      return Promise.reject(e);
    }
  }
}
